export type PlayerDossierRequestGate = {
    begin: () => number;
    invalidate: () => void;
    accepts: (request: number) => boolean;
};

export const createPlayerDossierRequestGate = (): PlayerDossierRequestGate => {
    let revision = 0;
    return {
        begin: () => {
            revision += 1;
            return revision;
        },
        invalidate: () => {
            revision += 1;
        },
        accepts: (request) => request === revision,
    };
};

const record = (value: unknown): Record<string, unknown> => value && typeof value === 'object' && !Array.isArray(value)
    ? value as Record<string, unknown>
    : {};

export const unwrapPlayerDossierDomain = (data: unknown, key: string) => {
    const root = record(data);
    const items = Array.isArray(root.items) ? root.items : [];
    const item = record(items[0]);
    const keyed = record(item[key]);
    if (Object.keys(keyed).length) return keyed;
    const nested = record(item.domain);
    return Object.keys(nested).length ? nested : item;
};
